"use strict";

var $ = jQuery;
import "cookieconsent/build/cookieconsent.min.js";

$(initCookieConsent);

function initCookieConsent() {
    window.cookieconsent.initialise({
    "palette": {
        "popup": {
        "background": "rgba(0, 0, 0, 0.8)",
        "text": "#ffffff"
        },
        "button": {
        "background": "",
        "text": "#4f2c1d"
        }
    },
    "theme": "classic",
    "content": {
        "message": "This website uses cookies to give you the best experience. By continuing to use this website, you agree to our use of cookies.",
        "dismiss": "Accept",
        "link": "Privacy Policy",
        "href": "https://www.adelphi.edu/privacy-policy/"
    }
    });
}
